/**
 * Dialogue history (`GET …/instances/{id}/messages`, oldest first) → chat
 * bubbles for ChatComponent.
 *
 * - `modality: "VOICE"` rows are call transcripts; the bubble shows a voice
 *   marker.
 * - `sessionDivider` marks where `session_index` changes. It is drawn only
 *   when the history spans more than one session, so a single-session
 *   Dialogue reads as a plain chat. Old rows can have a null index; they
 *   neither start nor break a session.
 */
export const toDialogueChatMessages = (messages = []) => {
  const rows = (messages || []).filter(
    (m) => (m?.role === "user" || m?.role === "assistant") && m?.content
  );
  const sessions = new Set(
    rows.map((m) => m.session_index).filter((i) => i !== null && i !== undefined)
  );
  const showDividers = sessions.size > 1;
  let lastSession = null;
  return rows.map((m) => {
    const index = m.session_index ?? null;
    const startsSession = showDividers && index !== null && index !== lastSession;
    if (index !== null) lastSession = index;
    return {
      id: m.id,
      role: m.role,
      content: m.content,
      modality: m.modality || "TEXT",
      ...(startsSession ? { sessionDivider: `Session ${index}` } : {}),
    };
  });
};

export default toDialogueChatMessages;
